module.exports = __webpack_public_path__ + "static/media/shoulders6.bd85ba5f.png";